import { useState } from 'react';
import {
    Typography,
    Paper,
    Box
} from '@mui/material';
import RoundButton from '../shared/components/round-btn';
import styles from './view-card.module.scss';
import ViewInfo from './view-info';

const ViewCatgory = ({ category, infos, uiStore }) => {
    const [selectedType, setSelectedType] = useState(category.data.sectionTypes[0]._id);

    const handleChange = (newValue) => {
        setSelectedType(newValue);
    };

    return (
        <Paper variant='round' sx={{ padding: '20px', mb: 2 }}>
            <Typography fontWeight={700}>{category.name}</Typography>

            {category.data.sectionTypes.length > 1 &&
                category.data.sectionTypes?.map((type, index) => (
                    <RoundButton
                        variant={selectedType === type._id && 'contained'}
                        color='greyPrimary'
                        onClick={() => handleChange(type._id)}
                        key={category._id + type._id}
                        size='small'
                        sx={{ mt: 1, mb: 1, mr: 1, fontSize: '12px' }}
                    >
                        {type._id}
                    </RoundButton>
                ))
            }

            {category.data.sections.filter(i => i.name === selectedType).map(section => {
                const labelsWithInfo = [];
                const filteredLabels = category.data.labels?.filter(i => i.section === section._id);
                filteredLabels.forEach(element => {
                    const info = infos.find(i => i.label === element._id);
                    if (info)
                        labelsWithInfo.push({ ...element, info });
                });

                return (
                    <Box key={section._id} className={styles.viewSection}>
                        {labelsWithInfo.map(item =>
                            <ViewInfo key={item._id} label={item} uiStore={uiStore} />
                        )}
                    </Box>
                );
            })}

        </Paper>
    );
}

export default ViewCatgory;